import React from 'react';
import { useParams, useHistory } from 'react-router';
import {
  Box,
  Button,
  Card,
  Divider,
  Icon,
  Typography
} from '@material-ui/core';
import { useStyles } from '../styles';


const QuoteItems = () => {
  const classes = useStyles();
  const history = useHistory();
  const params = useParams<{ [id: string]: string }>();
  const isPatientGroupActive = location.pathname.includes('/quoting/group/');

  const handleButtonClick = () => {
    if (isPatientGroupActive) {
      history.push(`/quoting/group/${params?.id}/quote-workspace`);
    } else {
      history.push(`/quoting/profile/${params?.id}/quote-workspace`);
    }
  };

  return (
    <>
      <Card className={`p-4 pb-6 root-card ${classes.gridItem}`}>
        <Typography variant="h5" gutterBottom className="mb-4">
          Quote Items
        </Typography>
        <Divider />
        <Box
          mt={3}
          px={2}
          py={3}
          border={1}
          display="flex"
          justifyContent="space-between"
          borderRadius={4}
          borderColor="grey.300"
        >
          <Button
            color="primary"
            variant="outlined"
            size="large"
            className={classes.customQuotePatientButton}
            onClick={handleButtonClick}
          >
            <Icon className={classes.customIcon}>search</Icon>
            <span className="capitalize font-bold">Search Items</span>
          </Button>
        </Box>
      </Card>
    </>
  );
};

export default QuoteItems;
